import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="font-heading text-xl font-semibold text-background-50 whitespace-nowrap cursor-pointer">
              年轻的母亲
            </Link>
            <p className="mt-3 text-sm text-background-50/60 leading-relaxed">
              专为年轻妈妈打造的育儿成长平台。我们相信，每一位年轻的母亲都值得在陪伴孩子的同时，活出自己最好的状态。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">
                  联系我们
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-background-50/60 leading-relaxed">
              加入我们的年轻母亲成长社群，与更多妈妈一起分享、学习和成长。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 年轻的母亲。保留所有权利。
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}